import { IBillingDetail } from '@nkr/models/index';
import { DropdownButton, MenuItem } from 'react-bootstrap';

interface IProps {
    data: IBillingDetail,
    onPay: (donorId: number) => void,
    onMarkPaid: (donorId: number) => void
}

const ListRow = (props: IProps) => {
    const item = props.data;

    return (
        <tr>
            <td>{item.billableNephrectomy.transplantDate}</td>
            <td>{item.billableNephrectomy.chainId}/{item.billableNephrectomy.clusterNumber}/{item.billableNephrectomy.positionNumber}</td>
            <td>{item.billableNephrectomy.donor.center.alias} {item.billableNephrectomy.donor.rdnCenterId > 0 ? <span style={{ color: 'darkred' }}>({item.billableNephrectomy.donor.rdnCenterAlias})</span> : null}</td>
            <td>{item.billableNephrectomy.donor.alias}</td>
            <td>{item.billableNephrectomy.recipient.center.alias}</td>
            <td>{item.billableNephrectomy.recipient.alias}</td>
            <td>{item.claimType}</td>
            <td>
                <DropdownButton id={'ubp-' + props.data.swapNumber} bsStyle='primary' bsSize='xs' title='Actions'>
                    <MenuItem onClick={() => props.onPay(props.data.billableNephrectomy.donor.id)}>Pay</MenuItem>
                    <MenuItem onClick={() => props.onMarkPaid(props.data.billableNephrectomy.donor.id)}>Mark as Paid</MenuItem>
                </DropdownButton>
            </td>
        </tr>
    );
}

export default ListRow;